import * as yup from 'yup';

export const featureModeSchema = yup.mixed<'H' | 'R' | 'W'>().oneOf(['H', 'R', 'W']).default('H');
